var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"input-group input-group--select\" :class=\"{ 'input-group--required': !!required, 'input-group--invalid': isInvalid }\">\n    <label :for=\"`input-select${_uid}`\" class=\"input-group__label\">\n      {{ label }}\n      <slot></slot>\n    </label>\n\n    <multiselect :id=\"`input-select${_uid}`\"\n                 v-model=\"computedModel\"\n                 v-bind=\"vBind\"\n                 v-on=\"vOn\"\n                 v-validate=\"validation\"\n                 :name=\"computedName\"\n                 :options=\"options\"\n                 :track-by=\"idKey\"\n                 :label=\"tagKey\"\n                 :placeholder=\"placeholder\"\n                 :tagPlaceholder=\"tagPlaceholder\"\n                 :selectLabel=\"selectLabel\"\n                 :selectedLabel=\"selectedLabel\"\n                 :deselectLabel=\"deselectLabel\"\n                 :multiple=\"isMultiple\"\n                 :taggable=\"isTaggable\"\n                 :disabled=\"isDisabled\"\n                 :close-on-select=\"isCloseOnSelect\"\n                 :hide-selected=\"isHideSelected\"\n                 :class=\"inputClass\"\n                 class=\"input-group__input\"\n                 @tag=\"tagEvent\"\n                 @remove=\"removeEvent\"\n    >\n      <div slot=\"noResult\">{{ noResultLabel || $t('app.noResultFound') }}</div>\n      <div slot=\"noOptions\">{{ noOptionsLabel || $t('app.emptyList') }}</div>\n    </multiselect>\n\n    <transition name=\"slide\">\n      <div class=\"input-group__error-message\" v-if=\"isInvalid\">{{ errors.first(label) }}</div>\n    </transition>\n  </div>\n";
import Multiselect from 'vue-multiselect';
import { plainToClassFromExist } from 'class-transformer';
import { Component, Prop, Watch, Vue, Inject } from 'vue-property-decorator';
var build = function ($id, $tag) { return ({ $id: $id, $tag: $tag }); };
var InputSelect = /** @class */ (function (_super) {
    __extends(InputSelect, _super);
    function InputSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emptyResource = build(0, '');
        _this.model = [];
        _this.options = [];
        return _this;
    }
    Object.defineProperty(InputSelect.prototype, "isInvalid", {
        get: function () {
            // @ts-ignore
            return this.errors.first(this.label);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "computedName", {
        get: function () {
            return this.name || this.label || '-';
        },
        enumerable: true,
        configurable: true
    });
    InputSelect.prototype.valueEvent = function (val) {
        if (val instanceof Array) {
            this.model = val;
        }
        else {
            this.model = val || this.emptyResource;
        }
    };
    InputSelect.prototype.itemsEvent = function (val) {
        var _this = this;
        if (!this.isTaggable) {
            this.options = val.map(function (item) { return item || _this.emptyResource; });
        }
    };
    Object.defineProperty(InputSelect.prototype, "vBind", {
        get: function () {
            return __assign({}, this.$attrs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "vOn", {
        get: function () {
            var listeners = __assign({}, this.$listeners);
            delete listeners.input;
            return __assign({}, listeners);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "computedModel", {
        get: function () {
            if (this.simpleCompute) {
                return this.value || null;
            }
            var model = this.model;
            var options = this.options.filter(function (item) { return !!item; });
            if (this.isTaggable) {
                return model;
            }
            if (model instanceof Array) {
                var ids_1 = model.map(function (item) { return item.$id; });
                return options.filter(function (item) { return ids_1.find(function (id) { return item.$id === id; }); });
            }
            var id = model.$id;
            return options.find(function (item) { return item.$id === id; }) || null;
        },
        set: function (val) {
            if (this.simpleCompute) {
                this.$emit('input', val);
                return;
            }
            this.model = val || this.emptyResource;
            var options = this.options.filter(function (item) { return !!item; });
            if (this.isTaggable) {
                this.$emit('input', plainToClassFromExist(this.value, val || null));
                return;
            }
            var model = this.model;
            if (model instanceof Array) {
                var ids_2 = model.map(function (item) { return item.$id; });
                var resources = options.filter(function (item) { return ids_2.find(function (id) { return item.$id === id; }); });
                this.$emit('input', plainToClassFromExist(this.value, resources));
                return;
            }
            var id = model.$id;
            var resource = options.find(function (item) { return item.$id === id; }) || null;
            this.$emit('input', plainToClassFromExist(this.value, resource));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isMultiple", {
        get: function () {
            return this.isMultipleNotTaggable || this.isTaggable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isMultipleNotTaggable", {
        get: function () {
            return this.value instanceof Array && !this.isTaggable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isTaggable", {
        get: function () {
            return !!this.taggable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isDisabled", {
        get: function () {
            return !!this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isCloseOnSelect", {
        get: function () {
            return this.closeOnSelect !== null ? this.closeOnSelect : !this.isMultipleNotTaggable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSelect.prototype, "isHideSelected", {
        get: function () {
            return this.hideSelected !== null ? this.hideSelected : this.isMultipleNotTaggable;
        },
        enumerable: true,
        configurable: true
    });
    InputSelect.prototype.created = function () {
        if (this.validator) {
            // @ts-ignore
            this.$validator = this.validator;
        }
    };
    InputSelect.prototype.tagEvent = function (val) {
        var _a;
        if (!(this.model instanceof Array))
            throw Error('The v-model must be an Array for taggable selects');
        var model = this.model;
        var items = val
            .split(',')
            .map(function (value) { return build(Number(value.trim()), value.trim()); })
            .filter(function (item) { return !model.find(function (value) { return value.$id === item.$id; }); });
        model.push.apply(model, items);
        (_a = this.options).push.apply(_a, items);
        this.$emit('tag', items, this.options);
        this.$emit('input', this.model);
    };
    InputSelect.prototype.removeEvent = function (val) {
        this.$emit('remove', val, this.options);
    };
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "label", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "name", void 0);
    __decorate([
        Prop({ type: [Array, Object] }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "value", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "inputClass", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputSelect.prototype, "required", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputSelect.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: Boolean, default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "closeOnSelect", void 0);
    __decorate([
        Prop({ type: Boolean, default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "hideSelected", void 0);
    __decorate([
        Prop({ type: String, default: '$id' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "idKey", void 0);
    __decorate([
        Prop({ type: String, default: '$tag' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "tagKey", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], InputSelect.prototype, "items", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputSelect.prototype, "taggable", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "placeholder", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "tagPlaceholder", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "selectLabel", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "selectedLabel", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], InputSelect.prototype, "deselectLabel", void 0);
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "noResultLabel", void 0);
    __decorate([
        Prop({ type: String, default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "noOptionsLabel", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "validation", void 0);
    __decorate([
        Inject({ from: 'validator', default: null }),
        __metadata("design:type", Object)
    ], InputSelect.prototype, "validator", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], InputSelect.prototype, "simpleCompute", void 0);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], InputSelect.prototype, "valueEvent", null);
    __decorate([
        Watch('items', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], InputSelect.prototype, "itemsEvent", null);
    InputSelect = __decorate([
        Component({
            template: template,
            components: { Multiselect: Multiselect },
        })
    ], InputSelect);
    return InputSelect;
}(Vue));
export { InputSelect };
//# sourceMappingURL=InputSelect.js.map